import { render, staticRenderFns } from "./OrderDetailBubble.vue?vue&type=template&id=06ff5c23&"
import script from "./OrderDetailBubble.vue?vue&type=script&lang=js&"
export * from "./OrderDetailBubble.vue?vue&type=script&lang=js&"
import style0 from "./OrderDetailBubble.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VContainer } from 'vuetify/lib/components/VGrid';
installComponents(component, {VContainer})
